<!--
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
-->
<template>
  <div>
    <label class="btn btn-secondary" for="exw_file">{{ $t(btnLabel) }}</label>
    <input type="file" id="exw_file" @change="onChange" style="display: none;">
  </div>
</template>
<script>
import * as wjcGridXlsx from '@grapecity/wijmo.grid.xlsx';
import SDLUtil from '@/utils/SDLUtil';

export default {
  name: 'WijmoExcelUpload',
  props: {
    btnLabel: {
      required: false,
      type: String,
      default: 'sdl.common.label.excelUpload',
    },
    btnClass: {
      type: String,
      default: 'btn btn-secondary',
    },
    wjimoDataGrid: {
      required: false,
      type: Object,
      default: () => {},
    },
    /* beforeClick: {
      type: Function,
      default: () => true,
    }, */
  },
  data() {
    return {
      files: [],
    };
  },
  methods: {
    /**
     * param: event
     * return:
     * exception:
     * Description : Select attachment
     */
    onChange(e) {
      this.files = e.target.files || e.dataTransfer.files;

      const getFileExt = fileName => fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length).toLowerCase();
      const extList = 'xls|xlsx'.split('|');

      Object.keys(this.files).forEach(x => {
        if (!extList.includes(getFileExt(this.files[x].name))) {
          SDLUtil.alert(
            SDLUtil.getMsgProp('sdl.common.message.extensionCannotBeAttached', [`${getFileExt(this.files[x].name)}`]),
          );
          this.files = [];
          e.target.value = '';
        }
      });
      console.log('a6666');

      if (this.files != null && this.files.length !== 0) {
        this.upload();
      }
    },
    /**
     * param:
     * return:
     * exception:
     * Description : click upload button
     */
    /* onBeforeUpload() {
      if (this.files.length === 0) {
        SDLUtil.alert('sdl.common.message.selectFile');
        return;
      }
      if (!this.beforeClick()) return;

      SDLUtil.confirm({
        msg: 'sdl.common.message.wouldYouLikeUploadExcel',
        // title: 'confirm title',
        // okLabel: 'ok label',
        // cancelLabel: 'Cancel',
        onOkEvt: () => this.upload(),
      });
    }, */
    /**
     * param:
     * return:
     * exception:
     * Description : upload attachment
     */
    upload() {
      console.log('asd');
      console.log(this.files[0]);
      console.log(this.wjimoDataGrid);
      if (this.files[0] != null && this.wjimoDataGrid != null) {
        this.customContent = false;
        wjcGridXlsx.FlexGridXlsxConverter.loadAsync(
          this.wjimoDataGrid,
          this.files[0],
          { includeColumnHeaders: true },
        );
      }
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/common/control/excel/WijmoExcelUpload.vue